// extracted by mini-css-extract-plugin
export var active = "_g-8";
export var addWidgetButton = "_g-9";
export var backButton = "_g-1";
export var pageContainer = "_g-2";
export var settingsContent = "_g-0";
export var sideNavContainer = "_g-6";
export var sideNavLink = "_g-7";
export var widgetContainer = "_g-5";
export var widgetSubsectionItem = "_g-3";
export var widgetSubsectionItemContent = "_g-4";